import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { ContributeLink } from "~/components/ContributeLink"
import { ColorSchemeUIDs } from "~/enums/ColorSchemes"
import { getClassesByColorScheme } from "~/utils/style/colorSchemes"

export type ContributeSectionProps = {
  colorSchemeId: string
}

export const ContributeSection: React.FC<ContributeSectionProps> = ({
  colorSchemeId,
}) => {
  const { t } = useTranslation("articlePage")

  const colorSchemeClasses = getClassesByColorScheme({
    colorScheme: {
      uid:
        colorSchemeId === ColorSchemeUIDs.VIOLET
          ? ColorSchemeUIDs.BLUE
          : ColorSchemeUIDs.VIOLET,
    },
  })

  return (
    <aside
      className={clsx(
        "max-w-screen-md md:text-center",
        "mx-auto sm:my-12 md:my-16",
      )}
    >
      <div
        className={clsx(
          "mx-auto p-4 py-6 md:py-8",
          colorSchemeClasses.bg,
          colorSchemeClasses.text,
        )}
      >
        <h1
          className={clsx("mb-2 text-xl md:text-2xl", colorSchemeClasses.text)}
        >
          {t("contributeSection.title")}
        </h1>
        <p className="mt-2 mb-4">{t("contributeSection.body")}</p>
        <div className="flex justify-center">
          <ContributeLink
            className={clsx(
              "font-display font-semibold",
              "bg-secondary-400 text-primary-900 theme-peach:text-gray-900",
              "no-underline",
              "rounded py-2 px-4",
            )}
          >
            {t("contributeSection.link")}
          </ContributeLink>
        </div>
      </div>
    </aside>
  )
}
